import { Select } from 'antd';
import { useUser } from 'providers/Users/UserProvider';
import React, { useEffect } from 'react';

const SpecialistSelect = ({ onChange, defaultValue }) => {
  const { call, isLoading, especialistas, hasCalled } = useUser();
  const [selected, setSelected] = React.useState(defaultValue);
  useEffect(() => {
    if (!hasCalled) {
      call();
    }
  }, [hasCalled, call]);
  const onChangeSelect = (value) => {
    onChange(value);
    setSelected(value);
  };
  useEffect(() => {
    setSelected(defaultValue);
  }, [defaultValue]);
  return (
    <Select
      size="small"
      loading={isLoading}
      variant="borderless"
      className="w-full !capitalize"
      placeholder="Especialista"
      onChange={onChangeSelect}
      showSearch
      value={selected}
      popupMatchSelectWidth={false}
      styles={{ popup: { root: { minWidth: '200px', maxWidth: '300px' } } }}
      optionLabelProp="label"
      filterOption={(input, option) => {
        return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
      }}
      filterSort={(optionA, optionB) =>
        (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
      }
    >
      {especialistas
        ?.sort((a, b) => a.fullname.localeCompare(b.fullname))
        ?.map((opt) => (
          <Select.Option
            value={opt.id}
            key={opt.id}
            label={opt.fullname}
            className="capitalize text-sm whitespace-nowrap"
          >
            <div className="whitespace-nowrap overflow-visible">{opt.fullname}</div>
          </Select.Option>
        ))}
    </Select>
  );
};

export default SpecialistSelect;
